export const heroStats = [
  { id: 'stat-1', value: '1,286', label: '深扒专题' },
  { id: 'stat-2', value: '3,542', label: '长图组图' },
  { id: 'stat-3', value: '96', label: '话题标签' },
  { id: 'stat-4', value: '24,800+', label: '逐层解析结论' },
];

export const heroTags: string[] = [
  '长图深扒',
  '时间线还原',
  '聊天记录',
  '多图对比',
  '幕后关联',
  '动态对比',
  '逐层拆解',
  '证据链',
];

export const heroCovers: string[] = [
  'https://readdy.ai/api/search-image?query=Moody%20editorial%20flat%20lay%20of%20scattered%20printed%20documents%20and%20torn%20paper%20collage%20on%20a%20dark%20walnut%20desk%2C%20dramatic%20warm%20amber%20side%20light%2C%20deep%20shadows%2C%20subtle%20film%20grain%2C%20muted%20crimson%20accents%2C%20restrained%20negative%20space%2C%20high%20detail%20cinematic%20still%20life%20photography&width=600&height=800&seq=hltw-hero-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Cinematic%20close%20up%20of%20a%20glowing%20phone%20screen%20beside%20stacks%20of%20old%20photographs%20on%20textured%20linen%20surface%2C%20warm%20amber%20desk%20lamp%20glow%2C%20heavy%20chiaroscuro%20shadow%2C%20grainy%20analog%20texture%2C%20muted%20taupe%20and%20red%20palette%2C%20quiet%20editorial%20composition%20with%20generous%20negative%20space%2C%20premium%20magazine%20aesthetic&width=600&height=800&seq=hltw-hero-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20magnifying%20glass%20over%20a%20timeline%20sketch%20and%20connected%20pins%20on%20a%20corkboard%2C%20warm%20amber%20directional%20light%2C%20deep%20brown%20shadows%2C%20fine%20film%20grain%2C%20muted%20crimson%20string%20accents%2C%20clean%20minimal%20framing%20with%20soft%20negative%20space%2C%20high%20detail%20documentary%20mood&width=600&height=800&seq=hltw-hero-03&orientation=portrait',
];

export const topics = [
  { id: 'topic-1', label: '长图深扒', count: '328', hot: true },
  { id: 'topic-2', label: '时间线还原', count: '214', hot: true },
  { id: 'topic-3', label: '聊天记录', count: '186', hot: true },
  { id: 'topic-4', label: '多图对比', count: '152', hot: false },
  { id: 'topic-5', label: '幕后关联', count: '141', hot: true },
  { id: 'topic-6', label: '动态对比', count: '118', hot: false },
  { id: 'topic-7', label: '逐层拆解', count: '109', hot: false },
  { id: 'topic-8', label: '证据链', count: '96', hot: false },
  { id: 'topic-9', label: '关键节点', count: '88', hot: false },
  { id: 'topic-10', label: '前因后果', count: '74', hot: false },
  { id: 'topic-11', label: '舆情走向', count: '63', hot: false },
  { id: 'topic-12', label: '关联人物', count: '57', hot: false },
];

export const featureItem = {
  id: 'feature-1',
  title: '深扒长图｜一场舆论反转的 48 小时：从聊天记录到公开动态的逐层还原',
  summary:
    '把散落的聊天截图、秒删动态与三版封面按时间顺序重新排列，逐层核对措辞差异，看清黑料图文内幕是怎样一步步被拼出来的。整组深扒长图共 42 张，附关键节点对照表。',
  tag: '长图深扒',
  cover:
    'https://readdy.ai/api/search-image?query=Wide%20cinematic%20flat%20lay%20of%20a%20long%20scroll%20of%20printed%20screenshots%20unrolled%20across%20a%20dark%20wooden%20table%20with%20a%20magnifying%20glass%20and%20red%20marker%20annotations%2C%20warm%20amber%20directional%20light%2C%20deep%20shadows%2C%20fine%20film%20grain%2C%20muted%20crimson%20and%20taupe%20tones%2C%20editorial%20documentary%20composition%20with%20strong%20depth%2C%20high%20detail&width=1200&height=800&seq=hltw-feature-01&orientation=landscape',
  imageCount: '42 张长图',
  views: '3.2 万',
  comments: '486',
  time: '2 小时前',
};

export const feedItems = [
  {
    id: 'feed-1',
    title: '凌晨三点的聊天截图，如何拼出一条完整时间线',
    summary: '把零散的对话按分钟排序，中间缺失的那段正好落在关键节点上。',
    tag: '聊天记录',
    cover:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20dim%20phone%20screen%20showing%20a%20chat%20thread%20beside%20a%20notebook%20of%20timestamps%20on%20a%20dark%20desk%2C%20warm%20amber%20glow%2C%20deep%20shadow%2C%20visible%20film%20grain%2C%20muted%20red%20pen%20marks%2C%20moody%20editorial%20still%20life%2C%20restrained%20composition%2C%20high%20detail%20texture&width=800&height=500&seq=hltw-feed-01&orientation=landscape',
    imageCount: '12 张',
    views: '8,240',
    comments: '312',
    time: '3 小时前',
  },
  {
    id: 'feed-2',
    title: '从一条秒删动态，倒推整件事真正的起点',
    summary: '发布时间、配图顺序、文案措辞，三条线索指向同一个下午。',
    tag: '时间线还原',
    cover:
      'https://readdy.ai/api/search-image?query=Desk%20scene%20with%20a%20hand%20drawn%20timeline%20on%20aged%20paper%20and%20small%20pinned%20photos%20along%20the%20line%2C%20warm%20amber%20task%20light%2C%20deep%20brown%20shadows%2C%20delicate%20film%20grain%2C%20muted%20crimson%20pins%2C%20quiet%20editorial%20documentary%20mood%2C%20clean%20negative%20space%2C%20sharp%20detail&width=800&height=500&seq=hltw-feed-02&orientation=landscape',
    imageCount: '18 张',
    views: '6,910',
    comments: '248',
    time: '5 小时前',
  },
  {
    id: 'feed-3',
    title: '同一场景的三版封面，哪一版被悄悄换过',
    summary: '把三版封面并排放大，边角的阴影走向出卖了修改痕迹。',
    tag: '多图对比',
    cover:
      'https://readdy.ai/api/search-image?query=Three%20printed%20photo%20proofs%20laid%20side%20by%20side%20on%20a%20dark%20table%20under%20a%20magnifier%2C%20warm%20amber%20side%20light%2C%20deep%20contrast%20shadow%2C%20soft%20grain%2C%20muted%20taupe%20and%20red%20accents%2C%20precise%20editorial%20flat%20lay%2C%20restrained%20composition%20with%20negative%20space%2C%20high%20detail&width=800&height=500&seq=hltw-feed-03&orientation=landscape',
    imageCount: '9 张',
    views: '5,470',
    comments: '176',
    time: '7 小时前',
  },
  {
    id: 'feed-4',
    title: '两份通稿的措辞差异，藏着同一条线索',
    summary: '同一段事实，两次发布的动词不一样，指向的责任方也就不一样。',
    tag: '幕后关联',
    cover:
      'https://readdy.ai/api/search-image?query=Two%20printed%20press%20drafts%20on%20a%20dark%20oak%20desk%20with%20red%20underlines%20and%20a%20vintage%20typewriter%20blurred%20behind%2C%20warm%20amber%20lamp%20light%2C%20deep%20shadow%2C%20subtle%20film%20grain%2C%20muted%20crimson%20accents%2C%20moody%20editorial%20still%20life%2C%20quiet%20negative%20space%2C%20high%20detail%20paper%20texture&width=800&height=500&seq=hltw-feed-04&orientation=landscape',
    imageCount: '15 张',
    views: '4,860',
    comments: '203',
    time: '9 小时前',
  },
  {
    id: 'feed-5',
    title: '群聊里被撤回的那句话，前后对得上吗',
    summary: '把撤回前后的两段对话接起来，语气断层比内容更值得看。',
    tag: '聊天记录',
    cover:
      'https://readdy.ai/api/search-image?query=Dim%20screen%20glow%20reflected%20on%20a%20dark%20table%20with%20a%20notepad%20tracking%20deleted%20messages%2C%20warm%20amber%20highlight%2C%20heavy%20low%20key%20shadow%2C%20fine%20analog%20grain%2C%20muted%20red%20annotation%20lines%2C%20intimate%20editorial%20still%20life%2C%20restrained%20framing%2C%20crisp%20detail&width=800&height=500&seq=hltw-feed-05&orientation=landscape',
    imageCount: '11 张',
    views: '4,210',
    comments: '159',
    time: '11 小时前',
  },
  {
    id: 'feed-6',
    title: '三个时间点串起来，故事走向就完全变了',
    summary: '把三个节点放进同一条时间轴，原本合理的解释立刻站不住。',
    tag: '关键节点',
    cover:
      'https://readdy.ai/api/search-image?query=Wooden%20drafting%20table%20with%20a%20timeline%20ruler%2C%20three%20red%20marked%20milestones%20and%20a%20brass%20compass%2C%20warm%20amber%20task%20lighting%2C%20deep%20brown%20shadows%2C%20gentle%20film%20grain%2C%20muted%20crimson%20and%20taupe%20palette%2C%20editorial%20documentary%20composition%2C%20clean%20negative%20space%2C%20high%20detail&width=800&height=500&seq=hltw-feed-06&orientation=landscape',
    imageCount: '14 张',
    views: '3,980',
    comments: '132',
    time: '13 小时前',
  },
  {
    id: 'feed-7',
    title: '公开动态与私下说法，差了不止一点',
    summary: '把两套叙述叠在一起看，重复出现的词反而是最生硬的部分。',
    tag: '动态对比',
    cover:
      'https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20two%20columns%20of%20printed%20posts%20on%20a%20dark%20slate%20surface%20with%20highlight%20marker%20notes%2C%20warm%20amber%20side%20light%2C%20deep%20shadow%2C%20subtle%20film%20grain%2C%20muted%20red%20and%20grey%20tones%2C%20analytical%20editorial%20mood%2C%20restrained%20layout%2C%20high%20detail&width=800&height=500&seq=hltw-feed-07&orientation=landscape',
    imageCount: '16 张',
    views: '3,560',
    comments: '121',
    time: '16 小时前',
  },
  {
    id: 'feed-8',
    title: '截图、时间戳、水印，逐层核对一遍',
    summary: '从最外层的水印位置核对到最里层的时间戳，一处对不上就重看。',
    tag: '证据链',
    cover:
      'https://readdy.ai/api/search-image?query=Forensic%20desk%20scene%20with%20a%20loupe%2C%20printed%20screenshots%20and%20a%20checklist%20of%20timestamps%20on%20dark%20wood%2C%20warm%20amber%20focused%20light%2C%20deep%20chiaroscuro%20shadow%2C%20fine%20film%20grain%2C%20muted%20crimson%20marks%2C%20precise%20documentary%20still%20life%2C%20quiet%20negative%20space%2C%20crisp%20detail&width=800&height=500&seq=hltw-feed-08&orientation=landscape',
    imageCount: '20 张',
    views: '3,140',
    comments: '108',
    time: '18 小时前',
  },
];

export const shortNews = [
  { id: 'short-1', tag: '逐层拆解', title: '把同一段话放进三个版本里比对，重复的那句最可疑', meta: '6 图 · 2,140 阅读' },
  { id: 'short-2', tag: '时间线还原', title: '新增的两个时间点，把整条线往前推了四小时', meta: '9 图 · 1,860 阅读' },
  { id: 'short-3', tag: '幕后关联', title: '发布时间只差七分钟，两份说明像约好了一样', meta: '5 图 · 1,540 阅读' },
  { id: 'short-4', tag: '多图对比', title: '第四张长图的边角，藏着被裁掉的一行字', meta: '7 图 · 1,270 阅读' },
];

export const timelineNodes = [
  { id: 'tl-1', stamp: 'T-3 天', title: '私域聊天记录流出', text: '最先传出的是一段不完整的对话，中间缺失的部分后来才补上。' },
  { id: 'tl-2', stamp: 'T-2 天', title: '首条公开动态发布', text: '措辞克制，配图却换了顺序，发布时间与聊天记录对得上。' },
  { id: 'tl-3', stamp: 'T-1 天', title: '多图对比出现分歧', text: '三版封面被并排放出，边角阴影显示其中一版经过修改。' },
  { id: 'tl-4', stamp: 'T0', title: '时间线被重新排列', text: '把节点按分钟重排后，原本清晰的解释出现了断层。' },
  { id: 'tl-5', stamp: 'T+1 天', title: '幕后关联浮出水面', text: '两份通稿的动词差异，指向同一批发布节奏。' },
  { id: 'tl-6', stamp: 'T+2 天', title: '全貌逐层呈现', text: '聊天记录、公开动态与对比图归位，前因后果连成一条线。' },
];

export const layers = [
  { id: 'layer-1', level: '01', name: '表层｜公开动态', text: '只看得到台面上的几句话，信息和发布时间都经过挑选。' },
  { id: 'layer-2', level: '02', name: '中层｜聊天记录', text: '私域里的说法和公开版本对不上，删改痕迹集中在同一晚。' },
  { id: 'layer-3', level: '03', name: '线索层｜多图对比', text: '同一事件的不同封面被并排放大，阴影与水印先露出破绽。' },
  { id: 'layer-4', level: '04', name: '关联层｜幕后关联', text: '通稿措辞、发布时间与转述口径，共同指向同一条线。' },
  { id: 'layer-5', level: '05', name: '全貌层｜时间线还原', text: '前因后果与关键节点逐层归位，一次看清内幕全貌。' },
];

export const comments = [
  {
    id: 'c-1',
    user: '熬夜深扒协会',
    initial: '熬',
    content: '第 3 张长图的截图水印位置和大家手里的版本不一样，这一层拆得确实细。',
    likes: 286,
    time: '1 小时前',
    badge: '高赞',
  },
  {
    id: 'c-2',
    user: '时间线爱好者',
    initial: '时',
    content: '把两天动态排进同一条轴，节奏一下就清楚了，建议出个竖版长图方便存。',
    likes: 214,
    time: '2 小时前',
    badge: '热评',
  },
  {
    id: 'c-3',
    user: '吃瓜但讲逻辑',
    initial: '逻',
    content: '先看证据链再看结论，别被标题带跑，这组黑料图文解析的节奏刚好。',
    likes: 173,
    time: '2 小时前',
    badge: '',
  },
  {
    id: 'c-4',
    user: '图文考古队',
    initial: '考',
    content: '翻了旧封面，确实换过一次，角落那行字被裁掉得太刻意了。',
    likes: 129,
    time: '4 小时前',
    badge: '',
  },
  {
    id: 'c-5',
    user: '冷静观察员',
    initial: '观',
    content: '逐层拆解这部分写得克制，没急着下结论，这点很难得。',
    likes: 96,
    time: '5 小时前',
    badge: '',
  },
  {
    id: 'c-6',
    user: '路人甲',
    initial: '路',
    content: '评论区的分析比正文还细，已经把这组长图存下来了。',
    likes: 64,
    time: '6 小时前',
    badge: '',
  },
];

export const hotList = [
  { id: 'hot-1', rank: '01', title: '48 小时反转时间线：全 42 张长图整理', views: '3.2 万' },
  { id: 'hot-2', rank: '02', title: '三版封面并排比对，阴影走向对不上', views: '2.4 万' },
  { id: 'hot-3', rank: '03', title: '两份通稿的动词差异逐句拆解', views: '1.9 万' },
  { id: 'hot-4', rank: '04', title: '被撤回的那句话，前后语境完整还原', views: '1.6 万' },
  { id: 'hot-5', rank: '05', title: '关键节点对照表：把三个时间点串起来', views: '1.2 万' },
];

export const pollOptions = [
  { id: 'poll-1', label: '先看时间线还原', votes: 486 },
  { id: 'poll-2', label: '先看多图对比', votes: 352 },
  { id: 'poll-3', label: '先看聊天记录', votes: 274 },
  { id: 'poll-4', label: '先看幕后关联', votes: 198 },
];